<!--
 * @Descripttion: 文本框设置
 * @Author: zenghua.wang
 * @Date: 2021-12-01 10:19:42
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:14:52
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="文本框设置">
      <el-form-item label="文本类型">
        <el-radio-group
          v-model="data.option.multiline"
          size="mini"
        >
          <el-radio-button :label="false">单行</el-radio-button>
          <el-radio-button :label="true">多行</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="文本内容">
        <el-input
          v-if="data.option.multiline"
          v-model="data.option.value"
          type="textarea"
          :rows="4"
          clearable
          placeholder="请输入"
        />
        <el-input
          v-if="!data.option.multiline"
          v-model="data.option.value"
          type="text"
          clearable
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.fontSize"
          :max="200"
        />
      </el-form-item>

      <el-form-item label="字体行高(px)">
        <el-input-number
          v-model="data.option.lineHeight"
          :max="100"
        />
      </el-form-item>

      <el-form-item label="左右间距(px)">
        <el-input-number v-model="data.option.margin" />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <!-- <el-form-item label="字体背景">
        <el-color-picker
          v-model="data.option.backgroundColor"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item> -->

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.fontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="对齐方式">
        <el-select
          v-model="data.option.textAlign"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <el-collapse-item
      title="跑马灯设置"
      v-if="!data.option.multiline"
    >
      <el-form-item label="开启">
        <el-switch
          v-model="data.option.animation"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item
        label="滚动速度"
        v-if="data.option.animation"
      >
        <el-input-number v-model="data.option.animationTime" />
      </el-form-item>
    </el-collapse-item>

    <!-- 超链接 -->
    <config-link :data="data" />

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>
<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configLink from '@/dragComponents/config/common/link.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-text',
  components: {
    configBase,
    configLink,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      weightList: component.weightType,
      alignList: component.alignType
    }
  }
}
</script>
